export default class DeviceResource {
  constructor(client) {
    this.client = client;
  }

  list() {
    return this.client.get("/devices").then((resp) => resp.data);
  }

  update(deviceId, params) {
    return this.client
      .patch("/devices/" + deviceId, params)
      .then((resp) => resp.data);
  }

  updateDownlink(deviceId, downlink) {
    return this.client
      .patch("/devices/" + deviceId + "/downlink", { downlink })
      .then((resp) => resp.data);
  }

  updateTemperatureCorrection(deviceId, temperature_correction) {
    return this.client
      .patch("/devices/" + deviceId + "/temperature_correction", {
        temperature_correction,
      })
      .then((resp) => resp.data);
  }
}
